import { useAtomValue } from 'jotai'
import { FC, useContext } from 'react'

import { RichTextEditor } from 'packages/components/RichText'
import { PaperQuestion, QuestionTypeEnum } from 'packages/sdks-next/growp'

import { WaringText } from '@/components/Styled'
import { EditPaperContext } from '@/features/test-paper/pages/EditPaper/context'
import { QuestionSetting } from '@/features/test-paper/types'

import { isValidQuestionFieldAtom } from '../../atom'
import { PaperQuestionWithReq } from '../../types'

import { EditChoiceAnswer } from './EditChoiceAnswer'
import { EditFullInBlankAnswer } from './EditFullInBlankAnswer'

export type EditAnswerProps = {
  type: QuestionTypeEnum
  answers: {
    options: string[]
    standardAnswers: string[]
    settings: QuestionSetting
    subQuestions: PaperQuestionWithReq[]
    mainQuestion?: PaperQuestionWithReq
  }
  onEditAnswer: (val: {
    options?: string[]
    standardAnswers?: string[]
    settings?: QuestionSetting
    subQuestions?: PaperQuestion[]
  }) => void
}

export type EditAnswerComponent<T = object> = FC<EditAnswerProps & T>

/**
 * 编辑答案组件
 *
 * @param props - Argument Object
 * @param props.type - 题型
 * @param props.answers - 答案
 * @param props.onEditAnswer - 编辑答案
 * @returns 组件
 */
export const EditAnswer: FC<EditAnswerProps> = (props) => {
  const { limitLevel } = useContext(EditPaperContext)
  const { type, onEditAnswer, answers } = props
  const { standardAnswers } = answers
  const isValidField = useAtomValue(isValidQuestionFieldAtom)

  switch (type) {
    case QuestionTypeEnum.SingleChoice:
    case QuestionTypeEnum.MultipleChoice:
      return <EditChoiceAnswer {...props} />
    case QuestionTypeEnum.ShortAnswer:
      return (
        <>
          <RichTextEditor
            readOnly={limitLevel > 0}
            onChange={(val) => {
              onEditAnswer({ standardAnswers: [val] })
            }}
            minHeight={64}
            value={standardAnswers[0] || ''}
            excludeKeys={[
              'headerSelect',
              'group-upload',
              'insertLink',
              'fullScreen',
            ]}
            insertKeys={{
              index: 17,
              keys: ['uploadImage', 'insertFormula'],
            }}
          />
          {standardAnswers[0] || !isValidField ? null : (
            <WaringText>请添加答案</WaringText>
          )}
        </>
      )
    case QuestionTypeEnum.FillInBlank:
      return <EditFullInBlankAnswer {...props} />
    default:
      return <div>未知题型</div>
  }
}
